// Temporarily simplified for debugging
export default defineNuxtRouteMiddleware(async (to, from) => {
  const user = useSupabaseUser();
  const { shouldShowOnboardingForm } = useOnboarding();

  // Only check for authenticated users
  if (!user.value) {
    return;
  }

  // Don't redirect if already on onboarding-related pages
  if (to.path === '/onboarding-form' || to.path === '/onboarding-complete') {
    return;
  }

  // Don't check onboarding for auth-related pages
  if (to.path === '/login' || to.path === '/confirm' || to.path === '/confirm-email' || to.path === '/reset-password') {
    return;
  }

  try {
    // Check if user should see onboarding form
    const shouldShow = await shouldShowOnboardingForm();
    
    if (shouldShow) {
      return navigateTo('/onboarding-form');
    }
  } catch (error) {
    console.error('Error in onboarding middleware:', error);
    // Don't block navigation if there's an error
  }
});